import React from 'react';

import createSvgIcon from './hoc/createSvgIcon';

export default createSvgIcon(
  () => (
    <svg
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.07 6.25L6.17 7.17C5.45 7.89 5 8.5 5 10H3V9.5C3 8.39 3.45 7.39 4.17 6.67L5.41 5.41C5.78 5.05 6 4.55 6 4C6 3.46957 5.78929 2.96086 5.41421 2.58579C5.03914 2.21071 4.53043 2 4 2C3.46957 2 2.96086 2.21071 2.58579 2.58579C2.21071 2.96086 2 3.46957 2 4H0C0 2.93913 0.421427 1.92172 1.17157 1.17157C1.92172 0.421427 2.93913 0 4 0C5.06087 0 6.07828 0.421427 6.82843 1.17157C7.57857 1.92172 8 2.93913 8 4C7.99856 4.84324 7.66434 5.65183 7.07 6.25ZM5 14H3V12H5V14Z"
        fill="white"
      />
    </svg>
  ),
  'QuestionMark',
  '0 0 8 14'
);
